import { Route } from "react-router-dom";
import AffiliateInvoiceScreen from "../../../container/Affiliate/AffiliateInvoiceScreen";
import CreateAffiliateInvoiceContainer from "../../../container/Affiliate/AffiliateInvoiceScreen/CreateAffiliateInvoice";
import { APP_URLS } from "../../../utils/constant";

const AffiliateInvoiceRoutes = (access = {}) => {
  const { create = false, view = false, edit = false } = access || {};
  const screenPermissions = { create, view, edit };

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.AFFILIATE_INVOICE.HOME}
          element={<AffiliateInvoiceScreen screenPermissions={screenPermissions} />}
        />
      )}
      {!!view && (
        <Route
          path={APP_URLS.AFFILIATE_INVOICE.VIEW}
          element={<CreateAffiliateInvoiceContainer isView={true} screenPermissions={screenPermissions} />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.AFFILIATE_INVOICE.EDIT}
          element={<CreateAffiliateInvoiceContainer isEdit={true} screenPermissions={screenPermissions} />}
        />
      )}
    </>
  );
};

export default AffiliateInvoiceRoutes;
